import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import prettyBytes from 'pretty-bytes';
import Thumb from '../../../components/Thumb';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import { getDownloadFile } from '../../../redux/actions/fileshare';
import { RASTER_MIME } from '../../../utils/file';
import { includes } from 'lodash';

const AttachmentList = (props) => {
  const { attachedFiles, onClearClick, cover, onSelectCover } = props;
  return (
    <>
      <Typography>Attached files </Typography>
      <List dense={true}>
        {attachedFiles.map((afo) => {
          const isImage = includes(RASTER_MIME, afo.mime_type);
          return (
            <ListItem key={afo.file_id}>
              <ListItemIcon>
                {isImage ? (
                  <Thumb src={afo.file_url} />
                ) : (
                  <InsertDriveFileIcon />
                )}
              </ListItemIcon>
              <ListItemText
                primary={afo.file_name}
                secondary={prettyBytes(afo.file_size_bytes)}
              />
              <ListItemSecondaryAction>
                {isImage && !!onSelectCover && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={cover === afo.member_file_id}
                        onChange={() => onSelectCover(afo.member_file_id)}
                      />
                    }
                    label="Cover"
                  />
                )}
                <Tooltip title="Download">
                  <IconButton
                    onClick={() => getDownloadFile(afo.file_url, afo.file_name)}
                  >
                    <CloudDownloadIcon />
                  </IconButton>
                </Tooltip>
                {!!onClearClick && (
                  <Tooltip titie="Delete">
                    <IconButton onClick={() => onClearClick(afo)}>
                      <ClearRoundedIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </>
  );
};

export default AttachmentList;
